import React from 'react';
import styles from './ActionText.module.scss';
import { ActionText } from './ActionText.tsx';

type OwnProps = {
  text: string;
  icon: string;
  onClickHandler?: () => void;
  disabled?: boolean;
};

export const ActionTextWithIcon = (props: OwnProps) => {
  const { onClickHandler, text, icon, disabled } = props;

  return (
    <div aria-disabled={disabled} className={styles.rowContainer}>
      <img src={icon} />
      <ActionText
        text={text}
        onClickHandler={onClickHandler}
        disabled={disabled}
      />
    </div>
  );
};
